module.exports = __webpack_public_path__ + "static/media/Anim_010.ac84aaa6.fbx";